// extracted by mini-css-extract-plugin
module.exports = {"header":"_MapSection_header__1LTqi","main__container":"_MapSection_main__container__1wcTV"};